import { ErrorBoundary } from "@shared/components/Organisms/ErrorBoundry/ErrorBoundary";
import { Container } from "@shared/components/Atoms/Container/Container.component";
import { useBlockDataMapping } from "@shared/hooks/useBlockDataMapping";
import FooterColumn from "./components/FooterColumn.component";
import { useGlobalSettings } from "@shared/hooks/useGlobalSettings";
import { FooterColumn as FooterColumnData } from "@shared/types/ContentTypes";
import S from "./Footer.module.scss";

export const Footer = () => {
    const { footer } = useGlobalSettings();

    return (
        <footer className={S.footer}>
            <Container className={S.columnWrapper}>
                <ErrorBoundary>
                    {footer?.footerContent?.items
                        ? footer?.footerContent?.items?.map(
                              (item: FooterColumnData, index: number) => {
                                  // eslint-disable-next-line react-hooks/rules-of-hooks
                                  const mappedData = useBlockDataMapping(
                                      item.content.contentType,
                                      item.content,
                                      undefined
                                  );
                                  return <FooterColumn key={index} {...mappedData} />;
                              }
                          )
                        : null}
                </ErrorBoundary>
            </Container>
        </footer>
    );
};
